// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1IoTg","footer":"ModalInfo_footer__2ratB"};